import { Box, makeStyles, Popover } from '@material-ui/core';
import { ReactComponent as ManuallyAddedPropertyIcon } from '../../images/manuallyaddedproperty.svg';
import { ReactComponent as ManuallyAddedPropertyIconSelected } from '../../images/manuallyaddedpropertyselected.svg';
import { ComparableProperty } from '../../types';
import { useRef, useState } from 'react';
import { CompPropertyThumbnail } from './compPropertyThumbnail';


const useStyles = makeStyles((theme) => ({
  icon: {
    width: "46px",
    height: "57px",
    color: "#1976d2"
  }
}));


interface ManuallyAddedComparableMarkerProps {
  property: ComparableProperty,
  onThumbnailClick?: () => void;
  isSelected: boolean;
}

export const ManuallyAddedComparableMarker = ({ property, onThumbnailClick, isSelected }: ManuallyAddedComparableMarkerProps) => {

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const markerRef = useRef(null);

  const handleClick = () => {
    setAnchorEl(markerRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleThumbnailClick = () => {
    setAnchorEl(null);
    onThumbnailClick && onThumbnailClick();
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const Icon = isSelected ? ManuallyAddedPropertyIconSelected : ManuallyAddedPropertyIcon;

  return (
    <Box style={{ position: "relative" }}>
      <div ref={markerRef}>
        <Icon className={classes.icon} onClick={handleClick} />
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <CompPropertyThumbnail property={property} onClick={handleThumbnailClick} />
      </Popover>
    </Box>

  );
};